/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React, { FC, useMemo } from "react";

import BackIcon from "@src/assets/images/back-ico.svg";
import { CurrentSignUpStep } from "./ducks/slices";

interface StepPathProps {
  count: number;
  currentStep: CurrentSignUpStep;
  wrapperClass?: string;
  isIndividual?: boolean;
  onBack: (stepBack: CurrentSignUpStep) => void;
}

export const StepPath: FC<StepPathProps> = ({
  count,
  currentStep,
  wrapperClass = "",
  isIndividual = true,
  onBack,
}) => {
  const countClass = useMemo(() => {
    if (count === 1) return "one";
    if (count === 2) return "two";
    if (count === 3) return "three";
  }, [count]);

  const labelName = useMemo(() => {
    if (currentStep === CurrentSignUpStep.CREDENTIAL) {
      return "Account Information";
    }

    if (currentStep === CurrentSignUpStep.PERSONAL_INFORMATION) {
      return isIndividual
        ? "Personal Information"
        : "Organization & Personal Information";
    }

    if (currentStep === CurrentSignUpStep.PREFERENCES) {
      return "Preferences";
    }
  }, [currentStep, isIndividual]);

  const handleOnBack = () => {
    let backStep = CurrentSignUpStep.CREDENTIAL;

    if (currentStep === CurrentSignUpStep.CREDENTIAL) {
      backStep = CurrentSignUpStep.TYPE;
    }

    if (currentStep === CurrentSignUpStep.PREFERENCES)
      backStep = CurrentSignUpStep.PERSONAL_INFORMATION;

    onBack(backStep);
  };

  return (
    <div className={`step-container ${wrapperClass}`}>
      <div className={`current-path  mb-2 `}>
        <div className={`current ${countClass}`}></div>
      </div>
      <div className="step flexbox">
        <div className="step__icon cursor-pointer" onClick={handleOnBack}>
          <img src={BackIcon} alt="Back Icon" />
        </div>
        <div className="step__info ml-3">
          <p className="text-muted">Step {count} of 3</p>
          <p className="label-step">{labelName}</p>
        </div>
      </div>
    </div>
  );
};
